/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'app/services/api.service';
import { ApiResponse, UsageReport } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class UsageReportService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  getUsageReport(clientId: number, startDate: string, endDate: string): Observable<ApiResponse<UsageReport[]>> {
    return this.http.get<ApiResponse<UsageReport[]>>(
      `${this.apiService.superAdminApi}/usage-report/${clientId}/${startDate}/${endDate}`
    );
  }

  getTotalNumberOfShipments(
    clientId: number,
    startDate: string,
    endDate: string,
    type: 'tendered_date' | 'load_creation_date'
  ): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>(
      `${this.apiService.superAdminApi}/usage-report/${clientId}/${startDate}/${endDate}/shipments/${type}`
    );
  }
}
